import { useCallback } from "react";
import { DiagnosisSection } from "@/features/patient/clinical-history/components/DiagnosisView";
import { useDiagnoses } from "@/features/patient/clinical-history/utils/adaptClinicalHistory";
import { type ConditionStatus } from "@/features/patient/records/api/dataPipelineApi";
import { useSetConditionStatus } from "@/portals/patient/api/patientQueries";
import { useFamily } from "@/portals/patient/context/FamilyContext";
import { useSearchFocusParam } from "@/shared/hooks/useSearchFocus";

export function DiagnosisPage() {
  const { diagnoses, isLoading } = useDiagnoses();
  const focus = useSearchFocusParam();
  // The patient only: never while viewing a family member's profile.
  const { activeDependent } = useFamily();

  // It moves to its new group at once; the records reload in the background.
  const { mutateAsync: markStatus } = useSetConditionStatus(activeDependent?.id);
  const setStatus = useCallback(async (id: string, status: ConditionStatus) => {
    await markStatus({ id, status });
  }, [markStatus]);

  return (
    <DiagnosisSection
      diagnoses={diagnoses}
      isLoading={isLoading}
      onSetStatus={setStatus}
      canEditStatus={!activeDependent}
      focus={focus}
    />
  );
}
